import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import { IzlaznaFakturaDto, IzlazneFaktureClient } from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IzlaznaFakturaDuplikatResolver
  extends BaseService
  implements Resolve<IzlaznaFakturaDto> {
  constructor(private _client: IzlazneFaktureClient, private _router: Router) {
    super();
  }

  resolve():
    | Observable<IzlaznaFakturaDto>
    | Promise<IzlaznaFakturaDto>
    | IzlaznaFakturaDto
    | null {
    let id = 0;
    try {
      id = this._router.getCurrentNavigation().extras.state.id;
    } catch {
      return null;
    }

    return this._client.duplicateFaktura(id).pipe(
      map((res) => res.data),
      catchError(this.handleError),
      finalize(() => {})
    );
  }
}
